import { Tooltip } from '@mui/material';
import type { SyncStatus } from '@weft/types';
import { SYNC_STATUSES } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';
import React from 'react';
import { FailedIcon } from './invoice-sync-status-label-icons/FailedIcon';
import { SyncedIcon } from './invoice-sync-status-label-icons/SyncedIcon';

type InvoiceSyncStatusLabelProps = {
  syncStatus: SyncStatus;
  syncStatusUpdatedAt: string;
  className?: string;
};

export const InvoiceSyncStatusLabel:React.FC<InvoiceSyncStatusLabelProps> = ({
  syncStatus,
  syncStatusUpdatedAt,
  className,
}) => {
  return (
    <div className={className}>
      {getSyncStatusIcon(syncStatus, syncStatusUpdatedAt)}
    </div>
  );
};

export function getSyncStatusIcon(syncStatus: SyncStatus, syncStatusUpdatedAt: string) {
  switch (syncStatus) {
    case SYNC_STATUSES.None:
      return <span/>;
    case SYNC_STATUSES.Synced:
      return (
        <Tooltip
          title={`Synced on ${syncStatusUpdatedAt}`}
          placement="top"
        >
          <div><SyncedIcon className='h-4.5 w-4.5'/></div>
        </Tooltip>
      );
    case SYNC_STATUSES.Failed:
      return (
        <Tooltip
          title={`Failed syncing on ${syncStatusUpdatedAt}`}
          placement="top"
        >
          <div><FailedIcon className='h-4.5 w-4.5'/></div>
        </Tooltip>
      );
    default:
      return raiseUnreachable(syncStatus);
  }
}
